import { render, staticRenderFns } from "./AFooterNavigation.vue?vue&type=template&id=5501fb74&scoped=true&functional=true"
import script from "./AFooterNavigation.vue?vue&type=script&lang=js"
export * from "./AFooterNavigation.vue?vue&type=script&lang=js"
import style0 from "./AFooterNavigation.vue?vue&type=style&index=0&id=5501fb74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5501fb74",
  null
  
)

export default component.exports